import { TableRowProps, Tr as TableRow } from '@chakra-ui/react';
import React from 'react';

export const Tr = (props: TableRowProps) => {
  return <TableRow bg={'blackAlpha.200'} {...props} />;
};
